import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag ta rast under kunskapsprovet?";
const SHORT_ANSWER = "Korta toalettbesök tillåts normalt, men provet pausas inte. Ingen mat eller dryck under provet.";

export const Route = createFileRoute("/fraga/far-jag-rast-under-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag ta rast under kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Funktionshindrade eller personer med medicinska behov kan ansöka om särskilda anpassningar (t.ex. förlängd tid) hos kommunen i förväg."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – upplägg" }}
      related={[{"to": "/fraga/hur-rattas-provet", "label": "Hur rättas kunskapsprovet?"}, {"to": "/fraga/vilken-paragraf-styr-kunskapsprovet", "label": "Vilken paragraf styr kunskapsprovet?"}, {"to": "/fraga/hur-bra-ar-folkhalsomyndighetens-databas", "label": "Hur ser kunskapsprovets frågedatabas ut?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag ta rast under kunskapsprovet?" },
      { name: "description", content: "Korta toalettbesök tillåts normalt, men provet pausas inte. Ingen mat eller dryck under provet." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-rast-under-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-rast-under-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-rast-under-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag ta rast under kunskapsprovet", url: "https://alkoholprovet.se/fraga/far-jag-rast-under-provet" },
      ]),
    ],
  }),
});
